module.exports = __webpack_public_path__ + "32de6247.png";